import { createGlobalStyle } from "styled-components"

// GlobalStyle defines top-level styles for the page,
// at a level higher than what individual styled components
// can control.
const GlobalStyle = createGlobalStyle`
	* {
		box-sizing: border-box;
	}
	#root {
		height: 100%;
	}
	a {
		color: #ccc;
	}
	table {
		width: 100%;
	}
	html, body {
		margin: 0;
		padding: 0;
		background: #292929;
		color: white;
		font-family: Helvetica, sans-serif;
		font-size: 14px;
		height: 100%;
	}
`

export default GlobalStyle
